import _ from 'lodash';
import moment from 'moment';
import { mapState } from 'vuex';
import * as fb from '../firebase';

import Icon from '../components/Utils/Icon.vue';
import Error from '../components/Utils/Error.vue';

export default {
  // Those components can be use everywhere
  components: {
    Icon,
    Error,
  },
  data() {
    return {
      littleScreen: 500,
      mediumScreen: 800,
      colors: {
        background: '#E6ECF0',
        primary: '#30A0EE',
        blue: '#1369a7',
        lightBlue: '#1369a730',
        red: 'rgb(126, 29, 29)',
        lightRed: 'rgb(184, 43, 43)',
        greyTransparent: 'rgba(110, 110, 110, .85)',
        error: '#ef5777',
        success: '#399683',
        warning: '#c99c09',
        light: '#F5F8FA',
        medium: '#657786',
        dark: '#34495E',
        white: '#fff',
        shadow: 'rgba(0, 0, 0, .4)',
        boxShadow: '0 5px 10px 1px $shadow',
      },
    };
  },
  mounted() {},
  computed: {
    ...mapState([
      'userProfile',
      'currentWorkspace',
      'currentWidth',
      'isTouchDevice',
      'isPlannedMealDragged',
      'workspaceIdToJoin',
    ]),
    isLoggedIn() {
      return this.userProfile !== null;
    },
    currentUserId() {
      return fb.auth.currentUser.uid;
    },
    currentUserRef() {
      return fb.usersCollection.doc(this.currentUserId);
    },
    currentWorkspaceId() {
      return _.get(this.currentWorkspace, 'id', null);
    },
    currentWorkspaceRef() {
      return _.get(this.currentWorkspace, 'ref', null);
    },
    shouldCreateWorkspace() {
      return _.get(this.userProfile, 'workspaces', []).length === 0;
    },

    isLittleScreen() {
      return this.currentWidth < this.littleScreen;
    },
    isMediumScreen() {
      return this.currentWidth < this.mediumScreen;
    },

    // Dev mode
    isDevMode() {
      return process.env.NODE_ENV === 'development';
    },

    // is Admin
    isAdmin() {
      return _.get(this.userProfile, 'isAdmin', false);
    },
  },
  filters: {
    date(date) {
      return moment(date).format('DD/MM/YYYY');
    },
    fullDate(date) {
      return moment(date).format('ddd DD MMM');
    },
  },
};
